import { signOut } from 'firebase/auth';
import { Box, Menu } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

import firebaseAuth from '../../../../auth/firebaseConfig';

const PostLoginNavbarDropdownMenu = () => {
  const logout = () => {
    signOut(firebaseAuth);
  };

  return (
    <Menu position="bottom-end" shadow="sm" width={150}>
      <Menu.Target>
        <Box my={15} mx={30}>
          <IconChevronDown size="18" />
        </Box>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={logout}>Logout</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default PostLoginNavbarDropdownMenu;
